const data = {
    token: 'TOKEN',
    profile: [
        {
            id: 1,
            firstName: 'Arden',
            lastName: 'Wang',
            company: 'Rakuten',
            email: 'admin@rakuten.com',
            phone: '+6512345678',
            token: 'TOKEN_1',
        },
        {
            id: 2,
            firstName: 'Melissa',
            lastName: 'Chan',
            company: 'Traveloka',
            email: 'admin@traveloka.com',
            phone: '+6512345678',
            token: 'TOKEN_2',
        },
    ],
    menus: [
        {
            id: 147,
            title: 'Seabass Burrito With Sour Cream Dressing',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Fish', 'Dairy'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-04T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Drink',
            price: 20,
        },
        {
            id: 146,
            title: 'Thai Green Curry Chicken',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Chicken', 'Dairy'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-04T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Vegetable',
            price: 110,
        },
        {
            id: 270,
            title: 'Beef Noodle Bowl',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Beef'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-04T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Vegetable',
            price: 120,
        },
        {
            id: 1620,
            title: 'Roasted Chicken Rice',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Chicken', 'Rice', 'Chilli'],
            labels: [],
            vendor: {
                name: 'Thailand Chicken Rice (Beach Road)',
            },
            servingDate: '2025-05-04T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Vegetable',
            price: 130,
        },
        {
            id: 1408,
            title: 'Yong Tofu',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Fish', 'Pork', 'Noodle', 'Chilli', 'Sweet sauce'],
            labels: [],
            vendor: {
                name: 'Tiong Bahru Yong Tao Hu (Tiong Bahru)',
            },
            servingDate: '2025-05-04T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Vegetable',
            price: 120,
        },
        {
            id: 1625,
            title: 'Nasi Lemak Ayam Taliwang',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Chicken', 'Fish', 'Rice'],
            labels: [],
            vendor: {
                name: 'Nasi Lemak Ayam Taliwang (Hougang)',
            },
            servingDate: '2025-05-04T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Vegetable',
            price: 80,
        },
        {
            id: 2171,
            title: 'Mixed Fish Soup with Rice',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Fish', 'Rice', 'Chilli', 'Fried Garlic'],
            labels: [],
            vendor: {
                name: 'Arcade Fish Soup (CBD)',
            },
            servingDate: '2025-05-04T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Vegetable',
            price: 130,
        },
        {
            id: 231,
            title: 'Vegetarian Fried Rice ',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Indian Veg'],
            labels: [],
            vendor: {
                name: 'Vegetarian A.S Indian Cuisine',
            },
            servingDate: '2025-05-04T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Side',
            price: 120,
        },
        {
            id: 269,
            title: 'Mushroom Pesto Pasta With Onsen Egg ',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-04T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Drink',
            price: 80,
        },
        {
            id: 218,
            title: 'Mesclun Salad Bowl ',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Hawker'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-04T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Dessert',
            price: 20,
        },
        {
            id: 137,
            title: 'Truffle Mushroom Pasta With Poached Egg',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Dairy'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-05T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Staple',
            price: 110,
        },
        {
            id: 125,
            title: 'Prawn And Squid Mee Goreng',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Fish', 'Dairy'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-05T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Drink',
            price: 100,
        },
        {
            id: 271,
            title: 'Char-Grilled Unagi Set',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Fish'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-05T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Staple',
            price: 80,
        },
        {
            id: 1745,
            title: 'Soya Sauce Chicken Noodle',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Chicken', 'Noodle'],
            labels: [],
            vendor: {
                name: 'Upp Cross St Soya Sauce Chicken Noodle & Rice (Tanjong Pagar)',
            },
            servingDate: '2025-05-05T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Vegetable',
            price: 80,
        },
        {
            id: 1666,
            title: 'Chicken Claypot Rice',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Chicken', 'Pork', 'Rice'],
            labels: [],
            vendor: {
                name: 'Woong Kee Ipoh Traditional Claypot Chicken Rice(Alexandra)',
            },
            servingDate: '2025-05-05T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Staple',
            price: 60,
        },
        {
            id: 1988,
            title: 'Ayam Indo Maggie',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Chicken', 'Noodle'],
            labels: [],
            vendor: {
                name: 'Geprek',
            },
            servingDate: '2025-05-05T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Dessert',
            price: 90,
        },
        {
            id: 1608,
            title: 'Salmon Mentai Bowl',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Fish', 'Rice'],
            labels: [],
            vendor: {
                name: 'Gogiyo (Toa Payoh)',
            },
            servingDate: '2025-05-05T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Dessert',
            price: 80,
        },
        {
            id: 230,
            title: 'Chapathi Set Meal ',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Indian Veg'],
            labels: [],
            vendor: {
                name: 'Vegetarian A.S Indian Cuisine',
            },
            servingDate: '2025-05-05T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Main',
            price: 60,
        },
        {
            id: 277,
            title: 'Mapo Tofu And Creamy Fried Oyster Mushroom',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Dairy'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-05T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Vegetable',
            price: 140,
        },
        {
            id: 219,
            title: 'Assorted Fruit Bowl',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Hawker', 'Vegan'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-05T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Main',
            price: 130,
        },
        {
            id: 142,
            title: 'Pan Seared Seabass Served With Corn Salsa',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Fish'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-06T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Dessert',
            price: 100,
        },
        {
            id: 264,
            title: 'Korean Fried Chicken With Cauliflower And Mash',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Chicken', 'Dairy'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-06T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Dessert',
            price: 20,
        },
        {
            id: 265,
            title: 'Tomato Parmesan Chicken With Vegetable Pasta',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Chicken', 'Dairy'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-06T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Side',
            price: 80,
        },
        {
            id: 1552,
            title: 'Nasi Lemak Set',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Chicken', 'Fish', 'Rice'],
            labels: [],
            vendor: {
                name: 'Tian Tian Nasi Lemak (Serangoon)',
            },
            servingDate: '2025-05-06T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Vegetable',
            price: 90,
        },
        {
            id: 1145,
            title: 'Lor Mee ',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Pork', 'Noodle'],
            labels: [],
            vendor: {
                name: 'Jia Cheng Lor Mee',
            },
            servingDate: '2025-05-06T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Main',
            price: 40,
        },
        {
            id: 2203,
            title: 'Ayam Percik',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Chicken', 'Rice'],
            labels: [],
            vendor: {
                name: 'The Little Red Hen (CBD)',
            },
            servingDate: '2025-05-06T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Drink',
            price: 140,
        },
        {
            id: 1214,
            title: 'Donburi',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Beef', 'Chicken', 'Rice'],
            labels: [],
            vendor: {
                name: 'Doco Donburi (Tanjong Pagar)',
            },
            servingDate: '2025-05-06T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Dessert',
            price: 120,
        },
        {
            id: 434,
            title: 'Vegetarian Set Meal',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Indian Veg'],
            labels: [],
            vendor: {
                name: 'Vegetarian A.S Indian Cuisine',
            },
            servingDate: '2025-05-06T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Main',
            price: 110,
        },
        {
            id: 272,
            title: 'Stir-Fried Udon With Grilled Tofu',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Vegan'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-06T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Dessert',
            price: 40,
        },
        {
            id: 218,
            title: 'Mesclun Salad Bowl ',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Hawker'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-06T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Side',
            price: 20,
        },
        {
            id: 163,
            title: 'Gnocchi Served With Asparagus, Mushroom, Feta Cheese',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Dairy'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-07T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Staple',
            price: 70,
        },
        {
            id: 273,
            title: 'Masak Merah Pasta With Pan Seared Barramundi',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Fish'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-07T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Dessert',
            price: 70,
        },
        {
            id: 365,
            title: 'Tom Yum Fried Rice And Seabass With Mango Salsa',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Fish'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-07T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Side',
            price: 130,
        },
        {
            id: 1566,
            title: 'Roasted Chicken Bento Set',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Chicken', 'Rice', 'Chilli'],
            labels: [],
            vendor: {
                name: 'Poh Kee Chicken Rice (Toa Payoh)',
            },
            servingDate: '2025-05-07T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Vegetable',
            price: 100,
        },
        {
            id: 1424,
            title: 'Wanton Mee',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Pork', 'Noodle'],
            labels: [],
            vendor: {
                name: 'Cho Kee Noodle',
            },
            servingDate: '2025-05-07T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Dessert',
            price: 90,
        },
        {
            id: 1811,
            title: 'Ayam Bakar',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Chicken', 'Rice'],
            labels: [],
            vendor: {
                name: 'Dans Kitchen (CBD)',
            },
            servingDate: '2025-05-07T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Main',
            price: 100,
        },
        {
            id: 1621,
            title: 'Mixed Fish Soup with Yam Rice (Without Milk)',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Fish', 'Rice', 'Chilli'],
            labels: [],
            vendor: {
                name: 'Golden Mile Fish Porridge & Seafood Soup',
            },
            servingDate: '2025-05-07T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Vegetable',
            price: 30,
        },
        {
            id: 482,
            title: 'Naan Set',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Dairy', 'Indian Veg'],
            labels: [],
            vendor: {
                name: 'Paribar Restaurant Indian Muslim Food',
            },
            servingDate: '2025-05-07T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Dessert',
            price: 40,
        },
        {
            id: 565,
            title: 'Miso Glazed Grilled Beancurd With Soba And Vegetables',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Vegan'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-07T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Drink',
            price: 130,
        },
        {
            id: 219,
            title: 'Assorted Fruit Bowl',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Hawker', 'Vegan'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-07T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Dessert',
            price: 60,
        },
        {
            id: 145,
            title: 'Honey Bbq Sauced Chicken Leg Served With Mash Potatoes',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Chicken', 'Dairy'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-08T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Staple',
            price: 20,
        },
        {
            id: 168,
            title: 'Japanese Cold Noodle',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Vegan'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-08T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Side',
            price: 110,
        },
        {
            id: 366,
            title: 'Salmon In Spicy Tomato Sauce Served With Pasta',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Fish'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-08T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Vegetable',
            price: 130,
        },
        {
            id: 1119,
            title: 'Curry Chicken Noodles ',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Chicken', 'Dairy', 'Noodle'],
            labels: [],
            vendor: {
                name: 'Da Po (Beach Road)',
            },
            servingDate: '2025-05-08T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Main',
            price: 120,
        },
        {
            id: 1599,
            title: 'Char Siew and Roasted Pork Rice',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Pork', 'Rice', 'Chilli'],
            labels: [],
            vendor: {
                name: 'Amoy Roasted Delight',
            },
            servingDate: '2025-05-08T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Staple',
            price: 60,
        },
        {
            id: 2237,
            title: 'Nasi Lemak Ayam Balado Set ',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Chicken', 'Rice'],
            labels: [],
            vendor: {
                name: 'Nasi Lemak Ayam Taliwang (Hougang)',
            },
            servingDate: '2025-05-08T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Side',
            price: 50,
        },
        {
            id: 1823,
            title: 'Chicken Kebap with Butter Rice',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Chicken', 'Rice'],
            labels: [],
            vendor: {
                name: 'Bosphorus Turkish Kebap (Beach Road)',
            },
            servingDate: '2025-05-08T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Side',
            price: 70,
        },
        {
            id: 258,
            title: 'Palak Paneer +  Rice',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Dairy', 'Indian Veg'],
            labels: [],
            vendor: {
                name: 'Paribar Restaurant Indian Muslim Food',
            },
            servingDate: '2025-05-08T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Side',
            price: 40,
        },
        {
            id: 564,
            title: 'Spanish Tortilla With Asapragus And Romesco',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Vegan'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-08T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Main',
            price: 140,
        },
        {
            id: 218,
            title: 'Mesclun Salad Bowl ',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Hawker'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-08T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 1,
            category: 'Side',
            price: 70,
        },
        {
            id: 262,
            title: 'Pan Seared Salmon With Cucumber Rita And Soy Soba',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Fish', 'Dairy'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-11T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Dessert',
            price: 80,
        },
        {
            id: 267,
            title: 'Tom Yum Macaroni With Char-Grilled Tiger Prawns',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Fish'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-11T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Main',
            price: 140,
        },
        {
            id: 556,
            title: 'Sichuan Chilli Oil Chicken',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Chicken'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-11T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Main',
            price: 40,
        },
        {
            id: 1666,
            title: 'Chicken Claypot Rice',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Chicken', 'Pork', 'Rice'],
            labels: [],
            vendor: {
                name: 'Woong Kee Ipoh Traditional Claypot Chicken Rice(Alexandra)',
            },
            servingDate: '2025-05-11T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Dessert',
            price: 70,
        },
        {
            id: 1333,
            title: 'Fishball Mee Pok Dry ',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Fish', 'Pork', 'Noodle'],
            labels: [],
            vendor: {
                name: 'Golden Mile Teochew Fishball Noodles',
            },
            servingDate: '2025-05-11T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Staple',
            price: 100,
        },
        {
            id: 1191,
            title: 'Nasi Lemak Rendang',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Chicken', 'Rice'],
            labels: [],
            vendor: {
                name: 'Warung Parsanga (CBD)',
            },
            servingDate: '2025-05-11T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Vegetable',
            price: 150,
        },
        {
            id: 1607,
            title: 'Bulgogi Bowl',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Beef', 'Pork', 'Rice'],
            labels: [],
            vendor: {
                name: 'Gogiyo (Bedok)',
            },
            servingDate: '2025-05-11T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Staple',
            price: 40,
        },
        {
            id: 246,
            title: 'Vegetarian Dosa Set ',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Dairy', 'Indian Veg'],
            labels: [],
            vendor: {
                name: 'North&South Authentic Indian Food',
            },
            servingDate: '2025-05-11T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Drink',
            price: 110,
        },
        {
            id: 152,
            title: 'Spice Pumpkin Served With Quinoa, Feta Cheese',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Dairy'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-11T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Drink',
            price: 130,
        },
        {
            id: 218,
            title: 'Mesclun Salad Bowl ',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Hawker'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-11T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Main',
            price: 140,
        },
        {
            id: 263,
            title: 'Fish Brioche Sandwich With Fries',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Fish', 'Dairy'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-12T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Dessert',
            price: 80,
        },
        {
            id: 164,
            title: 'Mutton Kofta With Spice Roasted Pumpkin',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Lamb', 'Dairy'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-12T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Vegetable',
            price: 100,
        },
        {
            id: 363,
            title: 'Chicken Pho',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Chicken'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-12T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Staple',
            price: 130,
        },
        {
            id: 1240,
            title: "Chicken Chop with Chef's Special Sauce",
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Chicken', 'Dairy', 'Rice', 'Tomato Ketchup', 'Chilli'],
            labels: [],
            vendor: {
                name: 'Chef K Western (Serangoon)',
            },
            servingDate: '2025-05-12T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Side',
            price: 120,
        },
        {
            id: 1107,
            title: 'Mixed Fish Soup with Thick Bee Hoon',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Fish', 'Dairy', 'Pork', 'Rice', 'Noodle', 'Chilli', 'Fried Garlic'],
            labels: [],
            vendor: {
                name: 'Arcade Fish Soup (CBD)',
            },
            servingDate: '2025-05-12T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Staple',
            price: 60,
        },
        {
            id: 1816,
            title: 'Ayam Penyet',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Chicken', 'Rice'],
            labels: [],
            vendor: {
                name: 'HAS Kitchen',
            },
            servingDate: '2025-05-12T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Main',
            price: 110,
        },
        {
            id: 1700,
            title: 'Seafood Soup',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Fish', 'Pork', 'Rice', 'Chilli'],
            labels: [],
            vendor: {
                name: 'Yan Ji Seafood Soup ( Marsiling)',
            },
            servingDate: '2025-05-12T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Drink',
            price: 70,
        },
        {
            id: 525,
            title: 'Vegetable Rice Set',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Indian Veg'],
            labels: [],
            vendor: {
                name: 'Paribar Restaurant Indian Muslim Food',
            },
            servingDate: '2025-05-12T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Side',
            price: 110,
        },
        {
            id: 266,
            title: 'Vegetarian Japchae With Sesame Spinach',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Vegan'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-12T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Side',
            price: 40,
        },
        {
            id: 219,
            title: 'Assorted Fruit Bowl',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Hawker', 'Vegan'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-12T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Staple',
            price: 140,
        },
        {
            id: 176,
            title: 'Miso Glazed Salmon With Soba And Vegetables',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Fish'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-13T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Vegetable',
            price: 150,
        },
        {
            id: 568,
            title: 'Crispy Honeyed Sriracha Chicken Bowl',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Chicken'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-13T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Dessert',
            price: 120,
        },
        {
            id: 380,
            title: 'Korean Pancake With Grilled Prawns',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Fish'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-13T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Drink',
            price: 40,
        },
        {
            id: 1877,
            title: 'Ten Tonic Chicken Soup with Yam Rice',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Chicken', 'Rice'],
            labels: [],
            vendor: {
                name: 'Ding Kee Super Soup (Ang Mo Kio)',
            },
            servingDate: '2025-05-13T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Side',
            price: 140,
        },
        {
            id: 1199,
            title: 'Yong Tau Fu (Dry)',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Fish', 'Pork', 'Noodle', 'Chilli', 'Sweet sauce'],
            labels: [],
            vendor: {
                name: 'Authentic Hakka Yong Tau Fu',
            },
            servingDate: '2025-05-13T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Side',
            price: 20,
        },
        {
            id: 3155,
            title: 'Beef Rendang Nasi Padang Set',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Beef', 'Chicken', 'Rice'],
            labels: [],
            vendor: {
                name: 'Istimewa (Home Kitchen) (Muslim-Owned) (Lavender)',
            },
            servingDate: '2025-05-13T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Dessert',
            price: 120,
        },
        {
            id: 1755,
            title: 'Vietnamese Dry Vermicelli',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Duck', 'Pork', 'Noodle'],
            labels: [],
            vendor: {
                name: 'Pho Hanoi (CBD)',
            },
            servingDate: '2025-05-13T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Drink',
            price: 40,
        },
        {
            id: 148,
            title: 'Masala Dosai + Onion Dosai',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Indian Veg'],
            labels: [],
            vendor: {
                name: "Buni's Tiffin Corner",
            },
            servingDate: '2025-05-13T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Staple',
            price: 150,
        },
        {
            id: 268,
            title: 'Vegetarian Red Thai Curry With Rice',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Dairy'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-13T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Main',
            price: 140,
        },
        {
            id: 218,
            title: 'Mesclun Salad Bowl ',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Hawker'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-13T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Main',
            price: 10,
        },
        {
            id: 265,
            title: 'Tomato Parmesan Chicken With Vegetable Pasta',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Chicken', 'Dairy'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-14T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Drink',
            price: 100,
        },
        {
            id: 476,
            title: 'Steamed Garlic Prawns With Vermicelli',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Fish'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-14T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Vegetable',
            price: 120,
        },
        {
            id: 359,
            title: 'Stir Fried Thai Basil Chicken With Rice',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Chicken'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-14T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Side',
            price: 40,
        },
        {
            id: 1736,
            title: 'Herbal Chicken Rice Set',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Chicken', 'Rice'],
            labels: [],
            vendor: {
                name: 'Bowl & Bowl (Toa Payoh)',
            },
            servingDate: '2025-05-14T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Main',
            price: 130,
        },
        {
            id: 1360,
            title: 'Signature Chili Ban Mian',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Fish', 'Pork', 'Noodle'],
            labels: [],
            vendor: {
                name: 'Grandma Ban Mee',
            },
            servingDate: '2025-05-14T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Dessert',
            price: 60,
        },
        {
            id: 1987,
            title: 'Ayam Geprek',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Chicken', 'Rice'],
            labels: [],
            vendor: {
                name: 'Geprek',
            },
            servingDate: '2025-05-14T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Staple',
            price: 30,
        },
        {
            id: 1650,
            title: 'Black Pork Bowl',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Pork', 'Rice'],
            labels: [],
            vendor: {
                name: 'Gogiyo (Bukit Merah)',
            },
            servingDate: '2025-05-14T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Dessert',
            price: 50,
        },
        {
            id: 337,
            title: 'Matar Paneer With Rice',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Dairy', 'Indian Veg'],
            labels: [],
            vendor: {
                name: 'Pak Kashmiri',
            },
            servingDate: '2025-05-14T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Side',
            price: 130,
        },
        {
            id: 364,
            title: 'Vegetarian Meat Balls With Chickpea And Tomato Stew',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Dairy'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-14T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Drink',
            price: 110,
        },
        {
            id: 219,
            title: 'Assorted Fruit Bowl',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Hawker', 'Vegan'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-14T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Side',
            price: 130,
        },
        {
            id: 144,
            title: 'Roasted Duck Breast Served With Orange Sauce, Mash Potato',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Duck', 'Dairy'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-15T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Side',
            price: 90,
        },
        {
            id: 573,
            title: 'Spicy Tomato Fish With Rice And House Salad',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Fish'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-15T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Dessert',
            price: 120,
        },
        {
            id: 325,
            title: 'Pad Thai With Thai Chilli Beancurd',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Vegan'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-15T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Side',
            price: 130,
        },
        {
            id: 1214,
            title: 'Donburi',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Beef', 'Chicken', 'Rice'],
            labels: [],
            vendor: {
                name: 'Doco Donburi (Tanjong Pagar)',
            },
            servingDate: '2025-05-15T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Vegetable',
            price: 70,
        },
        {
            id: 1092,
            title: 'Char Siew Wanton Noodles',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Pork', 'Noodle'],
            labels: [],
            vendor: {
                name: 'Wong Kee Wanton Noodles(Timbre)',
            },
            servingDate: '2025-05-15T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Main',
            price: 40,
        },
        {
            id: 1718,
            title: 'Nasi Padang Set',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Chicken', 'Rice'],
            labels: [],
            vendor: {
                name: 'Warung Parsanga Authentic Indonesian Cuisine',
            },
            servingDate: '2025-05-15T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Dessert',
            price: 70,
        },
        {
            id: 1107,
            title: 'Mixed Fish Soup with Thick Bee Hoon',
            description: '',
            image: '',
            images: [],
            isHalal: false,
            tags: ['Fish', 'Dairy', 'Pork', 'Rice', 'Noodle', 'Chilli', 'Fried Garlic'],
            labels: [],
            vendor: {
                name: 'Arcade Fish Soup (CBD)',
            },
            servingDate: '2025-05-15T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Side',
            price: 110,
        },
        {
            id: 583,
            title: 'Plain Dosa + Rava Dosa + Vadai X02',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Indian Veg'],
            labels: [],
            vendor: {
                name: "Buni's Tiffin Corner",
            },
            servingDate: '2025-05-15T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Dessert',
            price: 100,
        },
        {
            id: 368,
            title: 'Veggie Burrito With Chips And Pea Mash',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Dairy'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-15T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Vegetable',
            price: 100,
        },
        {
            id: 218,
            title: 'Mesclun Salad Bowl ',
            description: '',
            image: '',
            images: [],
            isHalal: true,
            tags: ['Vegetarian', 'Hawker'],
            labels: [],
            vendor: {
                name: 'Bistro Sedap',
            },
            servingDate: '2025-05-15T16:00:00.000Z',
            dishReview: {
                isNew: true,
                total: 0,
                visible: 0,
            },
            weekIdx: 2,
            category: 'Main',
            price: 40,
        },
    ],
    orderHistory: [
        {
            id: '1001',
            diningMethod: 'Takeaway',
            orderDate: '2025-05-08T16:00:00.000Z',
            lineitems: [
                {
                    id: 1,
                    vendor: 'Paribar Restaurant Indian Muslim Food',
                    title: 'Chicken Rice',
                    price: 50,
                    quantity: 2,
                    status: 'Unpaid',
                },
                {
                    id: 2,
                    vendor: 'Bistro Sedap',
                    title: 'Chicken Kebap with Butter Rice',
                    price: 70,
                    quantity: 1,
                    status: 'Paid',
                },
                {
                    id: 3,
                    vendor: 'Paribar Restaurant Indian Muslim Food',
                    title: 'Palak Paneer +  Rice',
                    price: 40,
                    quantity: 2,
                    status: 'Paid',
                },
                {
                    id: 4,
                    vendor: 'Chef K Western (Serangoon)',
                    title: 'Spanish Tortilla With Asapragus And Romesco',
                    price: 140,
                    quantity: 1,
                    status: 'Completed',
                },
            ],
            total: 390,
        },
        {
            id: '1002',
            diningMethod: 'DineIn',
            tableId: '101',
            orderDate: '2025-05-08T16:00:00.000Z',
            lineitems: [
                {
                    id: 1,
                    vendor: 'Paribar Restaurant Indian Muslim Food',
                    title: 'Chicken Rice',
                    price: 50,
                    quantity: 2,
                    status: 'Unpaid',
                },
                {
                    id: 2,
                    vendor: 'Bistro Sedap',
                    title: 'Chicken Kebap with Butter Rice',
                    price: 70,
                    quantity: 1,
                    status: 'Paid',
                },
                {
                    id: 3,
                    vendor: 'Paribar Restaurant Indian Muslim Food',
                    title: 'Palak Paneer +  Rice',
                    price: 40,
                    quantity: 2,
                    status: 'Paid',
                },
                {
                    id: 4,
                    vendor: 'Chef K Western (Serangoon)',
                    title: 'Spanish Tortilla With Asapragus And Romesco',
                    price: 140,
                    quantity: 1,
                    status: 'Completed',
                },
            ],
            total: 390,
        },
    ],
}

export default data
